import React from 'react';
import { Paper, Tooltip, Typography } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { formatNumber } from 'app/utils';

const Card = ({ title, data }) => {
  return (
    <Paper
      margin={2}
      marginLeft={0}
      sx={{
        color: ColorsV2.white,
        backgroundColor: ColorsV2.secondary,
        padding: '20px',
        width: 'max-content',
        minWidth: '175px',
      }}
    >
      <Typography borderBottom={`2px solid ${ColorsV2.outline}`} variant='subtitle2' color={ColorsV2.textInfo}>
        {title}
      </Typography>
      <Tooltip title={data} placement='right'>
        <Typography variant='h5' width='max-content'>
          {formatNumber(data, 1)}
        </Typography>
      </Tooltip>
    </Paper>
  );
};
export default Card;
